import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { SectionHeading } from './Shared';
const improvements = ['20 ready-to-use sessions organized by level and objective', '40+ drills already structured for immediate practical use', 'Over 500 operational pages to consult whenever you need', 'Weekly and seasonal planning that gives your program continuity', 'More fluidity managing your group and your court time', 'Less improvisation and significantly more perceived professionalism'];
export const WhatYouImprove = () => {
  return <section className="py-12 md:py-24 bg-slate-50 text-navy-900" data-id="element-270">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-271">
        <SectionHeading data-id="element-272">What You Improve With This Pack:</SectionHeading>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-id="element-273">
          {improvements.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} whileHover={{
          y: -2,
          boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.05)'
        }} className="flex items-start gap-3 md:gap-4 bg-white p-4 md:p-6 shadow-md border-l-4 border-green-500 rounded-r-xl transition-shadow duration-300" data-id="element-274">
              <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-green-500 flex-shrink-0 mt-0.5" data-id="element-275" />
              <p className="text-base md:text-lg font-semibold text-slate-800" data-id="element-276">
                {item}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};